export default __webpack_public_path__ + "static/media/1.cbda3527.png";